import React, { Component, PureComponent } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import { JsonLd } from 'react-schemaorg';
import scrollToComponent from 'react-scroll-to-component-ssr';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import Helmet from 'react-helmet';
import toNumber from 'lodash/toNumber';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import { numDescOnlyText } from 'helpers/numDesc';
import { authConnect, UserProp } from 'auth';
// import { daysDifAndTime, difDays } from 'helpers/formatDate';
import preload from 'api/data-preload';
import pageCache from 'api/page-cache';
import DataProvider from 'api/data-provider';
import Dict from 'api/data-dict';
import { simpleCheck } from 'api/data-check';
import seoPreload, { seoDecorator } from 'api/seo';
import GeoLandings from 'subsys/geo-landings';
import Comments, { commentsPreloader } from 'subsys/comments';
import { FavoritesButton, FavoriteWrapper } from 'subsys/favorites';
import contentBlock, { blockPreloader } from 'containers/content-block';
import Link from 'components/link';
import AdSense from 'components/adsense';
import sensor from 'components/sensor';
import Button from 'components/button';
import Row, { Col } from 'components/row';
import { SeoText } from 'components/layouts';
import Breadcrumbs from 'components/breadcrumbs';
import StarRating  from 'components/star-rating';
import Image, { OpenGraphImage, Thumb } from 'components/image';
import CommentRules from 'components/comment-rules';
import Icon, { iconTypes, socialsIconConfig } from 'components/icon';
import { getToponyms } from 'components/layouts/abstract-object-tile';
import Counter from 'subsys/counter';

import linksDomik from 'src-sites/domik/links';
import blockConfig from 'src-sites/domik/blocks/config';
import BlockWrapper from 'src-sites/domik/blocks/block-wrapper';
import ContactToDeveloper from 'src-sites/bild/section-project/contact-to-developer';
import { getAskDevHeader } from 'src-sites/bild/section-project/render-common';

import TileArticle from './article-tile';
import ContentRenderer from './publication-content';
import {
  renderToBack, renderRubricsList, SearchInput,
  // renderDevelopers, renderLC, renderCurrentRubrics
} from './render-common';
import { renderMainPrice } from '../section-project/cards-object/list-card';

import config from '../../../config';

import translates from './article-i18n';

import 'styles/domik/containers/content-block/_admin-editor.scss'; // TODO: Веталь, надо удалить когда будет работать Управление блоками
import 'styles/domik/blocks/_block-projects.scss'; // TODO: Веталь, надо удалить когда будет работать Управление блоками

import 'styles/domik/section-articles/_articles-search.scss';
import 'styles/domik/section-articles/_rubrics-list.scss';
import 'styles/domik/section-article/_page-article.scss';

const bemClasses = new Bem('pageArticle');
const bemClassesArticle = new Bem('article');
const classesBemToBack = new Bem('toBack');
const classesBemRubricsList = new Bem('rubricsList');
const bemClassesSearch = new Bem('articlesSearch');

@preload((routeProps) => {
  const { params, route } = routeProps;
  const { landing } = params;

  const entityId = route.servicePreview ? params.id : landing.entity_id;
  const cacheTerm = route.servicePreview ? null : 60;

  return {
    ...blockPreloader({
      project: 'domik',
      entity: 'publPage'
    }, blockConfig, []),
    publication: [DataProvider.preload, {
      url: route.servicePreview ? 'domik/news/publication-preview' : 'domik/news/publication',
      cache: cacheTerm,
      query: { id: entityId }
    }],
    ...commentsPreloader({
      entity: 'publications',
      entityId,
    }),
    otherPublications: {
      $wait: ['publication'],
      $callback: (data) => {
        const cfg = {};
        const ids = get(data, 'publication.data[0].rubrics_ids');

        cfg.list = ids ? [DataProvider.preload, {
          url: 'domik/news/publication-list',
          query: {
            idNot: entityId,
            rubricIds: ids,
            limit: 8,
            order: ['standart', 'desc']
          },
          queryJson: true,
          cache: 60,
          requestClientCache: 1
        }] : null;
        return cfg;
      }
    },
    lc: {
      $wait: ['publication'],
      $callback: (data) => {
        const cfg = {};
        const lcId = get(data, 'publication.data[0].lc_data[0].id');

        cfg.lc = lcId ? [DataProvider.preload, {
          url: "domik/location/newbuild",
          query: {
            id: lcId
          },
          cache: 60,
          requestClientCache: 1
        }] : null;
        return cfg;
      }
    },
    childLandings: {
      $wait: ['publication'],
      $callback: (data) => {
        const cfg = {};
        const landing_tree = get(data, 'publication.data[0].lc_data[0].landing_tree');

        cfg.childLandings = landing_tree ? [DataProvider.preload, {

          url: 'bild/complex-child-landings',
          cache: 60,
          requestClientCache: 1,
          query: {
            branch: landing_tree,
            entityNot: 'object'
          },
          queryJson: true
        }] : null;
        return cfg;
      }
    },
    rubricTree: [Dict.preload, { url: 'domik/publications/news-rubrics-tree' }],
    ...seoPreload({
      entity: 'publication'
    }, ['publication']),
    ...simpleCheck(['publication']),
    ...pageCache('publication')
  };
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@authConnect()
@sensor
@I18nHoc(translates())
export default class PagePubl extends Component {
  static propTypes = {
    className: PropTypes.string,
    auth: UserProp,
    checkPermission: PropTypes.func,
    seoData: PropTypes.shape({}),
    publication: PropTypes.shape({}),
    otherPublications: PropTypes.shape({}),
    lc: PropTypes.shape({}),
    childLandings: PropTypes.shape({}),
    rubric: PropTypes.shape({}),
    router: routerShape,
    params: PropTypes.shape({}),
    mainMenuBase: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.getInteractiveComponents = this.getInteractiveComponents.bind(this);
    this.scrollToRef = this.scrollToRef.bind(this);
    this.scrollToComments = this.scrollToComments.bind(this);
    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.state = {
      mounted: false,
      device: 'desktop'
    };
  }

  componentDidMount() {
    this.onHandleResize(this.sensor.getRuntime());
    this.setState({ mounted: true });
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;

    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  scrollToRef(ref) {
    const isSensor = this.sensor;
    const heightHeader = toNumber(isSensor.getVariable('heightHeaderPx'));

    scrollToComponent(ref, { offset: -heightHeader, align: 'top', duration: 700, ease: 'linear' });
  }

  scrollToComments() {
    this.scrollToRef(this.refBlockComments);
  }

  getInteractiveComponents(favData) {
    const publicationId = get(this, 'props.publication.data[0].id');
    const index = findIndex(favData, { entity_id: publicationId });

    return (
      <FavoritesButton
        {...bemClassesArticle('favorite')}
        project="domik"
        entity="publication"
        entityId={publicationId}
        subgroup="article"
        inFavorites={index > -1}
        hideLabel
      />
    );
  }

  renderShare() {
    const socials = {
      fb: config.fbDomik.url,
      telegram: config.telegramlink.url
    };

    return (
      <div {...bemClassesArticle('socials')}>
        {map(socials, (soc, key) => {
          if (soc) {
            return (
              <Link
                key={key}
                {...bemClassesArticle('link', ['social', socialsIconConfig[key]])}
                href={soc}
                noRedirector
                external
                blank
              >
                <span {...bemClassesArticle('linkContent')}>
                  <Icon {...bemClassesArticle('icon')} type={socialsIconConfig[key]} />
                </span>
              </Link>
            );
          }

          return null;
        })}
        <FavoriteWrapper project="domik" entity="publication">
          {({ data }) => this.getInteractiveComponents(data)}
        </FavoriteWrapper>
      </div>
    );
  }

  // TODO: Веталь, выпилить когда будет "Управление блоками" и перенести туда стили и логику
  _renderArticlesOther() {
    const { i18n } = this;
    // const { device } = this.state;
    let dataArticlesOther = get(this, 'props.otherPublications.list.data');

    // const isDesktop = device === 'desktop';
    // dataArticlesOther = isDesktop ? dataArticlesOther.slice(0, 3) : dataArticlesOther.slice(0, 2);
    dataArticlesOther = dataArticlesOther.slice(0, 3);
    const articles = map(dataArticlesOther, (item, key) => (
      <TileArticle
        key={key}
        data={item}
        dataMods="tile"
      />
    ));

    return (
      <div className="containerEditorAdmin blockPNews1">
        <div className="container container_body blockProjects">
          <div className="row blockProjects__rowTopic">
            <div className="col">
              <div className="blockProjects__text blockProjects__text_h2">
                <h2 children={i18n('readAlso')} />
              </div>
            </div>
          </div>
          <div className="blockProjects__projects" children={articles} />
        </div>
      </div>
    );
  }

  _renderComments() {
    const { i18n } = this;
    const { params: { landing } = {}, commentsList } = this.props;
    const url = null;

    if (!landing) {
      return null;
    }

    return (
      <div {...bemClasses('blockComments')} ref={ref => this.refBlockComments = ref}>
        <Row {...bemClasses('blockCommentsTopic')}>
          <Col allPr={0}><div {...bemClasses('text', 'topic')} children={i18n('commentsH2')} /></Col>
          <Col allAuto allPr={0}><CommentRules {...bemClasses('commentRules')} dataView="btnPageComment" /></Col>
        </Row>
        <Comments
          {...bemClasses('comments')}
          entity="publications"
          entityId={landing.entity_id}
          preloaded={commentsList}
          linkToAllComments={url}
          autoHideReply={false}
          updateEvent="updateCommentsCount"
          title={get(commentsList, 'count') > 0 &&
            <Row {...bemClasses('rowTopic')}>
              <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={i18n('commentsTitle')} /></div></Col>
            </Row>
          }
          subscribe={true}
          showCountNewComments={false}
          noVisitingCard={true}
        />
      </div>
    );
  }

  rating =()=> {
    const { i18n } = this;
    const id = get(this, 'props.publication.data[0].id');

    return (
      <Row {...bemClassesArticle('row', 'rating')}>
        <Col {...bemClassesArticle('col', 'label')} allAuto allPr={0}>
          <span {...bemClassesArticle('text')} children={i18n('toRateArticle')} />
        </Col>
        <Col {...bemClassesArticle('col', 'rating')} allPr={0}>
          <StarRating
            {...bemClassesArticle('rating')}
            entity='publications'
            entity_id={id}
          />
        </Col>
      </Row>
    );
  }

  handleSearch = (val) => {
    const { router, params } = this.props;
    const { landing = {} } = params;
    const { breadcrumbs } = landing;
    const pathname = breadcrumbs ? breadcrumbs[0].url : null;
    router.push({ pathname, query: { search: val } });
  }

  renderComplexData = () => {
    const lc = get(this, 'props.lc.lc.data[0]');
    const childLandings = get(this, 'props.childLandings.childLandings');

    if (!lc && !childLandings) return null;

    return (
      <div {...bemClasses('blockLcArticle')}>
        {!!lc && this.renderLc(lc)}
        {!!childLandings && this.renderChildLandings(childLandings)}
      </div>
    );
  }

  renderChildLandings(childLandings) {
    return (
      <div {...bemClasses('purchaseOptions')}>
        {this.renderObjectsGroup(childLandings)}
        {this.renderLinkObjectsAll(childLandings)}
      </div>
    );
  }

  renderLinkObjectsAll = (childLandings) => {
    const { i18n } = this;
    const data = filter(childLandings.data, val => val.level === 2);
    const url = get(data, '[0].url');
    const title = i18n('linkToLcObjects');

    if (!url) return null;

    return (
      <div {...bemClasses('purchaseOptionsFooter')}>
        <Link
          {...bemClasses('link', 'toObjects')}
          builder={linksDomik.sectionLanding}
          builderProps={{
            url,
            title
          }}
        >
          <span {...bemClasses('linkContent')}>
            <span {...bemClasses('text')} children={title} />
          </span>
        </Link>
      </div>
    );
  }

  renderLinkObjects(url, title) {
    if (!url) return null;

    return (
      <Link
        {...bemClasses('link', 'fill')}
        builder={linksDomik.sectionLanding}
        builderProps={{
          url,
          title
        }}
        children={<span />}
      />
    );
  }

  renderObjectsGroup(childLandings) {
    let data = filter(childLandings.data, val => val.level === 3);
    data = sortBy(data, val => get(val, 'data.sort'));

    if (!data || !data.length) return null;

    return map(data, (val = {}, key) => this.renderItemGroup(val, key));
  }

  renderItemGroup(val, key) {
    const data = get(val, 'data');
    const url = get(val, 'url');
    const { minArea, maxArea, all_area, land_area } = data;
    const name = get(val, 'data.value.value_long');
    const type = get(val, 'params.obj.type');
    const value = get(val, 'data.value');
    const apartmentName = value.value_long || value.entity_long;
    const apartmentValue = value.combo || value.value_long || value.entity_long || 1;
    const apartmentType = 'ROM';
    const landArea = land_area * 100;
    const areaTxt = minArea || all_area || landArea;
    const areaType = 'MTK';

    return (
      <div {...bemClasses('purchaseOptionsItem')} key={key}>
        {this.renderLinkObjects(url, null)}
        <Row {...bemClasses('purchaseOptionsItemContent')}>
          <Col {...bemClasses('purchaseOptionsItemCol')} allPr={0}>
            {!!name && <span {...bemClasses('text', 'objectName')} children={name} />}
          </Col>
          <Col {...bemClasses('purchaseOptionsItemCol')} allPr={0}>
            {renderMainPrice.call(this, data, bemClasses, true)}
          </Col>
          <Col {...bemClasses('purchaseOptionsItemCol')} allPr={0}>
            {this.renderArea(data)}
          </Col>
          <Col {...bemClasses('purchaseOptionsItemCol')} allPr={0} />
        </Row>
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'Apartment',
            name: apartmentName,
            url: absoluteUrl(url),
            numberOfRooms: (type === 'saleFlatNewbuild') ? {
              '@type': 'QuantitativeValue',
              value: apartmentValue,
              unitCode: apartmentType
            } : null,
            floorSize: {
              '@type': 'QuantitativeValue',
              maxValue: maxArea,
              minValue: minArea,
              value: areaTxt,
              unitCode: areaType
            }
          }}
        />
      </div>
    );
  }

  renderArea(data) {
    const { minArea, maxArea, all_area, land_area, groupId } = data;
    const land_area_type = get(data, 'land_area_type') || {};
    let areaType = !all_area && land_area && land_area_type ?
      numDescOnlyText(
        land_area,
        land_area_type.F1 || '',
        land_area_type.F2 || '',
        land_area_type.F3 || ''
      ) :
      'кв.м';
    const landArea = land_area_type.id === 2 ? land_area / 100 : land_area;
    let areaDiapason = minArea ? `${Math.floor(minArea)}` : null;

    if (groupId === 'lands') {
      areaType = numDescOnlyText(Math.floor(minArea), 'сотка', 'сотки', 'соток');
    }
    if (maxArea && Math.floor(maxArea) !== Math.floor(minArea)) {
      areaDiapason = `${areaDiapason} - ${Math.floor(maxArea)}`;
      if (groupId === 'lands') {
        areaType = numDescOnlyText(Math.floor(maxArea), 'сотки', 'соток', 'соток');
      }
    }

    const areaTxt = areaDiapason || all_area || landArea;

    if (areaTxt) return <span {...bemClasses('text', 'area')} children={`${areaTxt} ${areaType}`} />;

    return null;
  }

  renderLc = (lc) => {
    const toponym = lc.toponym;

    if (toponym) toponym.name = get(lc, 'toponym.display_name');

    return (
      <>
        <div {...bemClasses('imgLc')}>
          <div {...bemClasses('imgContainer')}>
            {this.renderLcLink(lc)}
            <div {...bemClasses('img')}>
              {this.renderImage(lc)}
              <div {...bemClasses('header')}>
                <div {...bemClasses('onPhoto', 'location')}>
                  {lc.display_name &&
                    <div {...bemClasses('location')}>
                      <span {...bemClasses('text')} children={lc.display_name} />
                    </div>
                  }
                  {toponym && getToponyms.call(this, null, toponym, {}, bemClasses)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          {...bemClasses('developerMain')}
          children={this.renderDeveloper(get(lc, 'main_developer[0]', {}))}
        />
        <div
          {...bemClasses('blockDeveloperCall')}
          children={this.renderContactToDeveloper(lc)}
        />
      </>
    );
  }

  renderDeveloper = (developer) => {
    if (!developer.url || !developer.name_short) return null;

    return (
      <Link
        {...bemClasses('link', 'toDeveloper')}
        builder={linksDomik.sectionLanding}
        builderProps={{
          ...developer,
          title: developer.name_short
        }}
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('imgContainer')}>
            <span {...bemClasses('img')}>
              <Thumb
                {...bemClasses('imgPic')}
                image={{ id: developer.avatar }}
                tagSpan
              />
            </span>
          </span>
          <span {...bemClasses('text')} children={developer.name_short} />
        </span>
      </Link>
    );
  }

  renderContactToDeveloper = (lc) => {
    const { i18n } = this;
    const { url, id, free_taxi } = lc;
    const mainDeveloper = get(lc, 'main_developer[0]', {});
    const salers = get(lc, 'salers');
    const indexPhone = findIndex(salers, (saler) => saler.parent === mainDeveloper.id);
    const salerPhone = get(salers, `[${indexPhone}].phones[0]`);
    const salerEmail = get(salers, `[${indexPhone}].contact_email`);

    if (!salerEmail && !salerPhone) return null;

    const askDevHeader = getAskDevHeader.call(this, bemClasses, lc);

    return (
      <ContactToDeveloper
        free_taxi={free_taxi}
        developer={mainDeveloper}
        salerEmail={salerEmail}
        salerPhone={salerPhone}
        projectId={id}
        projectUrl={url}
        askDevHeader={askDevHeader}
        otherPropsDD={{
          btnText: i18n('connectConsult'),
          btnIconSecondHide: true
        }}
      />
    );
  }

  renderLcLink(lc) {
    if (!lc.url || !lc.display_name) return null;

    return (
      <Link
        {...bemClasses('link', 'fill')}
        builder={linksDomik.sectionLanding}
        builderProps={{
          ...lc,
          title: lc.display_name
        }}
        children={<span />}
      />
    );
  }

  renderImage(data) {
    const {
      display_name: title,
      title_image = {}
    } = data;

    return (
      <>
        <Thumb
          {...bemClasses('imgPic')}
          image={{
            id: get(title_image, 'id'),
            alt: title,
            title
          }}
          tagSpan
        />
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'ImageObject',
            name: title || null,
            description: title || null,
            contentLocation: get(data, 'locality_display_name') ? get(data, 'locality_display_name') : null,
            contentUrl: get(title_image, 'id') ? absoluteUrl(`/images/thumb/full/${title_image.id}`) : null
          }}
        />
      </>
    );
  }

  render() {
    const { i18n } = this;
    const { params: { landing } = {}, seoData, publication, className, mainMenuBase, route, auth, checkPermission } = this.props;
    const { mounted, device } = this.state;
    const publData = get(publication, 'data[0]');
    const publicationId = get(this, 'props.publication.data[0].id');
    const commentsCount = get(this, 'props.commentsList.count', 0);
    const header = get(seoData, 'header') ? seoData.header : publData.name;
    const publImage = get(publData, 'image.id');
    const isDesktop = device === 'desktop';

    const headerElements = commentsCount ? [
      <Col key={1} {...bemClassesArticle('col', 'commentCount')} allAuto allFlex allColumn allPr={0}>
        <div {...bemClassesArticle('commentCount')}>
          <Button
            {...bemClassesArticle('btn', 'toComment')}
            onClick={this.scrollToComments}
            iconType={iconTypes.commentRound}
            label={`${commentsCount}`}
            title={i18n('toComments')}
          />
        </div>
      </Col>
    ] : null;

    const breadcrumbs = landing ? landing.breadcrumbs : [];

    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksDomik.sectionDomik,
        builderProps: { title: i18n('breadcrumbsMain') }
      },
      ...breadcrumbs
    ];

    const seoText = get(seoData, 'bottomText');
    const lc = get(this, 'props.lc.lc.data[0]');
    const counterEntity = {
      publication_id: publicationId
    }
    if (!!lc) {
      counterEntity.project_id = lc.id
    }

    return (
      <main {...bemClasses({ extra: className })}>
        <Counter
          entity={counterEntity}
          mode="view"
          action="pageNewsView"
        />
        {route.servicePreview &&
          <Helmet>
            <meta name="robots" content="noindex,nofollow" />
          </Helmet>
        }
        <LazyHydrate ssrOnly>
          <OpenGraphImage imageId={publImage} />
        </LazyHydrate>
        <Breadcrumbs
          {...bemClasses('breadcrumbs', 'top')}
          data={dataBreadcrumbs}
          replace={{
            $publication: header, // data.name,
          }}
          noJson
        />
        <div {...bemClasses('blockToBack')} children={renderToBack.call(this, classesBemToBack, mounted)} />
        <Row {...bemClasses('row', 'main')}>
          <Col {...bemClasses('col', 'main')} allFlex allColumn allPr={0}>
            <ContentRenderer
              {...bemClasses('article')}
              dataProvider="domik/news/publication"
              dataProviderParams={{ cache: 60 }}
              preloaded={publication}
              publicationId={landing && landing.entity_id}
              publicationUrl={landing && landing.url}
              headerElements={headerElements}
              headerOverride={get(seoData, 'header') ? seoData.header : null}
              shareElement={this.renderShare()}
              ratingElement={this.rating()}
              auth={auth}
              checkPermission={checkPermission}
            />
            <AdSense />
            <LazyHydrate whenIdle children={this._renderArticlesOther()} />
            <LazyHydrate whenVisible>
              {contentBlock(blockConfig, 'beforeComments1', this.props, { classNameWrapper: 'blockPArticleBeforeComments1', gtmProps: { 'place': 'Actions' } })}
            </LazyHydrate>
            <LazyHydrate whenIdle children={this._renderComments()} />
            <LazyHydrate whenVisible>
              {contentBlock(blockConfig, 'afterComments1', this.props, { classNameWrapper: 'blockPArticleAfterComments1', gtmProps: { 'place': 'Actions' } })}
              {contentBlock(blockConfig, 'afterComments2', this.props, { classNameWrapper: 'blockPArticleAfterComments2', gtmProps: { 'place': 'Actions' } })}
            </LazyHydrate>
          </Col>
          <Col {...bemClasses('col', 'aside')} allFlex mdColumn allAuto allPr={0}>
            <aside {...bemClasses('aside')}>
              {isDesktop &&
                <>
                  <SearchInput
                    {...bemClasses('search', { noJs: !mounted })}
                    classes={bemClassesSearch}
                    i18n={i18n}
                    onSearch={this.handleSearch}
                  />
                  {renderRubricsList.call(this, classesBemRubricsList)}
                </>
              }
              {this.renderComplexData()}
              <GeoLandings base={mainMenuBase} injectPropName="landingLinks" project="domik">
                <GeoLandingsWrapper {...this.props} />
              </GeoLandings>
            </aside>
          </Col>
        </Row>
        <LazyHydrate whenVisible>
          {contentBlock(blockConfig, 'bottom1', this.props, { classNameWrapper: 'blockPArticleBottom1', gtmProps: { 'place': 'Actions' } })}
          {contentBlock(blockConfig, 'bottom2', this.props, { classNameWrapper: 'blockPArticleBottom2', gtmProps: { 'place': 'Actions' } })}
          {contentBlock(blockConfig, 'bottom3', this.props, { classNameWrapper: 'blockPArticleBottom3', gtmProps: { 'place': 'Actions' } })}
        </LazyHydrate>
        <Breadcrumbs
          {...bemClasses('breadcrumbs')}
          data={dataBreadcrumbs}
          replace={{
            $publication: header, // data.name,
          }}
        />
        <SeoText data={seoText} />
      </main>
    );
    /*
    const { className, seoData, publication = {}, params: { page, landing } = {} } = this.props;
    const data = get(publication, 'data[0]');
    const currentRubrics = get(data, 'rubrics');
    const dataLC = get(data, 'lc_data');
    const socials = {
      fb: config.fbDomik.url,
      telegram: config.telegramlink.url
    };
    const {
      image: img_main, name, text, short_text: annotation,
      users_data: developers, time_to_publish, id
    } = data;
    const isDesktop = device === 'desktop';
    // const noDesktop = device === ('tablet' || 'phone');
    const seoText = get(seoData, 'bottomText');
    const header = get(seoData, 'header') ? seoData.header : name;
    const image = typeof img_main === 'string' ? { id: img_main } : img_main;
    const imageArticle = { ...image, renderer: 'orig', alt: header, title: header };
    const dataBreadcrumbs = [
      {
        name: 'Главная',
        builder: linksDomik.sectionDomik,
        builderProps: { title: 'Главная' }
      },
      ...landing.breadcrumbs
    ];
    const commentsCount = this.commentsCount();

    return (
      <main {...bemClasses({ extra: className })}>
        <div {...bemClasses('blockToBack')} children={renderToBack.call(this, classesBemToBack, mounted)} />
        <article>
          <div {...bemClasses('top')}>
            <Row {...bemClasses('row', 'articleInfo')}>
              <Col {...bemClasses('col', 'rubric')} allAuto allFlex allColumn allPr={0}>
                {renderCurrentRubrics.call(this, bemClasses, currentRubrics)}
              </Col>
              <Col {...bemClasses('col', 'time')} allAuto allFlex allColumn allPr={0}>
                <time
                  {...bemClasses('time')}
                  dateTime={time_to_publish}
                  children={daysDifAndTime.call(this, time_to_publish)}
                />
              </Col>
              <Col {...bemClasses('col', 'commentCount')} allAuto allFlex allColumn allPr={0}>
                <div {...bemClasses('commentCount')}>
                  <Button
                    {...bemClasses('btn', 'toComment')}
                    onClick={this.scrollToComments}
                    iconType={iconTypes.commentRound}
                    label={commentsCount}
                    title={i18n('toComments')}
                  />
                </div>
              </Col>
            </Row>
            <header {...bemClasses('title')}>
              <div {...bemClasses('text')}><h1 children={header} /></div>
            </header>
          </div>
          <Row {...bemClasses('row', 'main')}>
            <Col {...bemClasses('col', 'article')} allFlex allColumn allPr={0}>
              <Row {...bemClasses('row', 'top')}>
                <Col {...bemClasses('col', 'developers')} allFlex allPr={0}>
                  {renderDevelopers.call(this, bemClasses, developers)}
                  {renderLC.call(this, bemClasses, dataLC)}
                  {/*renderOpinion.call(this, bemClasses, data)*//*}
                </Col>
                <Col {...bemClasses('col', 'share')} allAuto allFlex allPr={0}>
                  {this.renderShare()}
                </Col>
              </Row>
              <div {...bemClasses('main')}>
                <Row {...bemClasses('row', 'img')}>
                  <Col {...bemClasses('col', 'img')} allPr={0}>
                    <div {...bemClasses('imgContainer')}>
                      <div {...bemClasses('img')}>
                        <Image
                          {...bemClasses('imgPic')}
                          image={imageArticle}
                          fullScreenSwitch="none"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <span {...bemClasses('text', 'main annotation')} children={annotation} />
                <span {...bemClasses('text', 'main')} dangerouslySetInnerHTML={{ __html: text }} />
              </div>
              <footer {...bemClasses('footer')}>
                <Row {...bemClasses('row', 'footerInfo')}>
                  <Col {...bemClasses('col', 'rating')} allAuto allPr={0}>
                    <DataProvider
                      updateEvent="updateRating"
                      url="common/rating/rating"
                      query={{
                        entity: 'publications',
                        entityId: id
                      }}
                      renderer={this.rating}
                    />
                  </Col>
                  <Col {...bemClasses('col', 'share')} allFlex allPr={0}>
                    {this.renderShare()}
                  </Col>
                </Row>
              </footer>
            </Col>
            {isDesktop &&
              <Col {...bemClasses('col', 'aside')} allFlex allColumn allAuto allPr={0} mt={0} mp={0}>
                <aside
                  {...bemClasses('aside')}
                  children={renderItemsList.call(this, classesBemRubricsList)}
                />
              </Col>
            }
          </Row>
        </article>
        <LazyHydrate whenVisible children={this._renderArticlesOther()} />
        <LazyHydrate whenVisible children={this._renderComments(data)} />
        <Breadcrumbs
          {...bemClasses('breadcrumbs')}
          data={dataBreadcrumbs}
          replace={{
            $publication: header, // data.name,
          }}
        />
        <SeoText data={seoText} />
      </main>
    );   */
  }
}

class GeoLandingsWrapper extends PureComponent {
  static propTypes = {
    landingLinks: PropTypes.shape({}),
    geolocation: PropTypes.shape({})
  };

  render() {
    const { landingLinks, geolocation } = this.props;

    return (
      <>
        {contentBlock(blockConfig, 'rightColumn1', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn2', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn3', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn4', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn5', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn6', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn7', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
      </>
    );
  }
}
